module.exports = __webpack_public_path__ + "img/Illustration-SM-2024.240b418e.png";